import { HeroStartState } from "./HeroStartState"

export class HeroScore {
    score: number
    gameCount: number

    constructor(score: number, gameCount: number) {
        this.score = score
        this.gameCount = gameCount
    }

    static compareScores = (scoreA: HeroScore, scoreB: HeroScore): number => {
        if (scoreA.gameCount === scoreB.gameCount) {
            return 0
        }
        if (scoreA.gameCount < scoreB.gameCount) {
            return -1
        } else {
            return 1
        }
    }

    // Static because when parsed from JSON this is not retained.
    static getDescription = (score: number): string => {
        let scoreDescription: string
        if (score < HeroStartState.LOW_SCORE_THRESHOLD) {
            scoreDescription = "Hero in Training"
        } else if (score < HeroStartState.MEDIUM_SCORE_THRESHOLD) {
            scoreDescription = "Hero!"
        } else {
            scoreDescription = "Super Hero!"
        }
        return scoreDescription
    }
}
